import styleInject from '../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".fi-library--Si1k6 {\n  position: relative;\n  display: inline-block;\n  width: 1.333333em;\n  line-height: 1em;\n  margin-right: 8px;\n}";
var styles = {"fi":"fi-library--Si1k6"};
styleInject(css_248z);

export { styles as default };
